export const privacyContent = {
  en: [
    {
      title: "1. Information We Collect",
      paragraphs: [
        "We collect information you provide when making a reservation or contacting us, including: full name, email address, phone number, flight details, pickup and drop-off locations, number of passengers and any special requests.",
        "We may also collect technical data such as IP address, browser type and site usage to improve our services.",
      ],
    },
    {
      title: "2. How We Use Your Information",
      paragraphs: [
        "We use your information to: process and confirm reservations, coordinate transportation, communicate with you about your booking, improve our services and comply with legal obligations.",
      ],
    },
    {
      title: "3. Sharing of Information",
      paragraphs: [
        "We do not sell or rent your personal information. We share data only with: our drivers and logistics operators (only what is needed to fulfill the ride), payment processors (Stripe, PayPal) and authorities when required by law.",
      ],
    },
    {
      title: "4. Security",
      paragraphs: [
        "We use reasonable technical and organizational safeguards, including HTTPS connections, encrypted storage and restricted access controls.",
      ],
    },
    {
      title: "5. Your Rights",
      paragraphs: [
        "You have the right to: access your data, request corrections, request deletion and object to processing. Contact rsv@hrmembers.com to exercise these rights.",
      ],
    },
    {
      title: "6. Cookies",
      paragraphs: [
        "We use essential cookies for site functionality and optional analytics cookies. You can manage cookies via your browser settings.",
      ],
    },
    {
      title: "7. Contact",
      paragraphs: [
        "For questions about this policy contact us at rsv@hrmembers.com or +1 912-933-4539.",
      ],
    },
  ],
  es: [
    {
      title: "1. Información que recopilamos",
      paragraphs: [
        "Recopilamos información que usted nos proporciona al hacer una reservación o contactarnos, incluyendo: nombre completo, correo electrónico, número de teléfono, información de vuelo, lugar de recogida y destino, número de pasajeros y solicitudes especiales.",
        "También podemos recopilar información técnica como dirección IP, tipo de navegador y datos de uso del sitio para mejorar nuestros servicios.",
      ],
    },
    {
      title: "2. Cómo usamos su información",
      paragraphs: [
        "Utilizamos su información para: procesar y confirmar reservaciones, coordinar el servicio de transporte, comunicarnos con usted sobre su reserva, mejorar nuestros servicios y cumplir con obligaciones legales.",
      ],
    },
    {
      title: "3. Compartir información",
      paragraphs: [
        "No vendemos ni alquilamos su información personal. Compartimos datos únicamente con: nuestros choferes y operadores logísticos (solo los datos necesarios para ejecutar el servicio), procesadores de pago (Stripe, PayPal) y autoridades cuando la ley lo requiera.",
      ],
    },
    {
      title: "4. Seguridad",
      paragraphs: [
        "Implementamos medidas técnicas y organizativas razonables para proteger su información, incluyendo conexiones HTTPS, almacenamiento cifrado y acceso restringido.",
      ],
    },
    {
      title: "5. Sus derechos",
      paragraphs: [
        "Usted tiene derecho a: acceder a su información, solicitar correcciones, solicitar la eliminación de sus datos y oponerse a su tratamiento. Para ejercer estos derechos contáctenos a rsv@hrmembers.com.",
      ],
    },
    {
      title: "6. Cookies",
      paragraphs: [
        "Utilizamos cookies esenciales para el funcionamiento del sitio y cookies analíticas opcionales. Puede gestionar las cookies desde la configuración de su navegador.",
      ],
    },
    {
      title: "7. Contacto",
      paragraphs: [
        "Para preguntas sobre esta política contáctenos en rsv@hrmembers.com o al +1 912-933-4539.",
      ],
    },
  ],
};

export const termsContent = {
  en: [
    {
      title: "1. Acceptance",
      paragraphs: [
        "By booking a service with Hard Rock Members you accept these terms and conditions in full.",
      ],
    },
    {
      title: "2. Reservations",
      paragraphs: [
        "Bookings should be made at least 12 hours in advance. Confirmation is sent by email once the information is received and verified.",
        "Prices shown are estimates in USD and may vary depending on destination, vehicle, season and additional requests.",
      ],
    },
    {
      title: "3. Payment",
      paragraphs: [
        "We accept Stripe (cards) and PayPal. Charges are in USD. Once the service is confirmed, the charge is considered final.",
      ],
    },
    {
      title: "4. Cancellations & Refunds",
      paragraphs: [
        "Cancellations more than 24 hours in advance: full refund. Between 12 and 24 hours: 50% refund. Less than 12 hours or no-show: no refund.",
        "Airline-caused delays do not incur additional fees — we monitor your flight in real time.",
      ],
    },
    {
      title: "5. Client Responsibility",
      paragraphs: [
        "The client must provide accurate flight information and notify us of any changes. Hard Rock Members is not liable for losses arising from incorrect information.",
        "Use of illegal drugs and aggressive behavior inside the vehicle is prohibited. Our drivers may terminate the service in case of non-compliance.",
      ],
    },
    {
      title: "6. Luggage",
      paragraphs: [
        "Each passenger is entitled to one suitcase and one carry-on. Additional or oversized luggage may require a larger vehicle.",
      ],
    },
    {
      title: "7. Liability & Insurance",
      paragraphs: [
        "All our vehicles carry current commercial insurance. Hard Rock Members is not responsible for delays caused by force majeure (weather, traffic, political events, etc.).",
      ],
    },
    {
      title: "8. Changes",
      paragraphs: [
        "We reserve the right to modify these terms at any time. The version in force is the one published at hrmembers.com.",
      ],
    },
    {
      title: "9. Jurisdiction",
      paragraphs: [
        "These terms are governed by the applicable laws of the State of Quintana Roo, Mexico and the State of Wyoming, USA, as applicable.",
      ],
    },
  ],
  es: [
    {
      title: "1. Aceptación",
      paragraphs: [
        "Al reservar un servicio con Hard Rock Members usted acepta estos términos y condiciones en su totalidad.",
      ],
    },
    {
      title: "2. Reservaciones",
      paragraphs: [
        "Las reservaciones deben hacerse con al menos 12 horas de anticipación. La confirmación se envía por correo electrónico una vez recibida y verificada la información.",
        "Los precios mostrados son estimaciones en USD y pueden variar según destino, vehículo, temporada y solicitudes adicionales.",
      ],
    },
    {
      title: "3. Pagos",
      paragraphs: [
        "Aceptamos pagos mediante Stripe (tarjetas) y PayPal. El cobro se realiza en USD. Una vez confirmado el servicio, el cargo se considera firme.",
      ],
    },
    {
      title: "4. Cancelaciones y reembolsos",
      paragraphs: [
        "Cancelaciones con más de 24 horas de anticipación: reembolso completo. Entre 12 y 24 horas: reembolso del 50%. Menos de 12 horas o no-show: sin reembolso.",
        "Las demoras causadas por la aerolínea no generan cargos adicionales — monitoreamos el vuelo en tiempo real.",
      ],
    },
    {
      title: "5. Responsabilidad del cliente",
      paragraphs: [
        "El cliente debe proporcionar información de vuelo correcta y notificarnos cambios. Hard Rock Members no es responsable por pérdidas derivadas de información incorrecta.",
        "Está prohibido el consumo de drogas ilegales y comportamiento agresivo en el vehículo. Nuestros choferes pueden terminar el servicio en caso de incumplimiento.",
      ],
    },
    {
      title: "6. Equipaje",
      paragraphs: [
        "Cada pasajero tiene derecho a una maleta y un equipaje de mano. Equipaje adicional o sobredimensionado puede requerir un vehículo mayor.",
      ],
    },
    {
      title: "7. Responsabilidad y seguro",
      paragraphs: [
        "Todos nuestros vehículos cuentan con seguro comercial vigente. Hard Rock Members no será responsable por demoras causadas por fuerza mayor (clima, tráfico, eventos políticos, etc.).",
      ],
    },
    {
      title: "8. Modificaciones",
      paragraphs: [
        "Nos reservamos el derecho de modificar estos términos en cualquier momento. La versión vigente es la publicada en hrmembers.com.",
      ],
    },
    {
      title: "9. Jurisdicción",
      paragraphs: [
        "Estos términos se rigen por las leyes aplicables en el estado de Quintana Roo, México y el estado de Wyoming, USA, según corresponda.",
      ],
    },
  ],
};
